import React from "react";

const Footer = () => {
  return (
    <div className="bg-white flex justify-center p-4">
      <div className="text-sm">
        <a href="https://www.agoraproduction.ca/" className="cursor-pointer" target="_blank" rel="noopener noreferrer">
          © 2024 Agora Production. All Rights Reserved.
        </a>
      </div>
    </div>
  );
};

export default Footer;
